export const AUTH_BANNER_CONFIG = {
  already_used: {
    variant: "info",
    title: "Already Activated",
    message: "Your account has already been activated. Please log in to continue.",
  },
  expired: {
    variant: "warning",
    title: "Link Expired",
    message: "Your activation link has expired. Request a new one below.",
  },
  invalid: {
    variant: "error",
    title: "Invalid Link",
    message: "Your activation link is invalid or missing. Request a new one below.",
  },
};
